// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Button" (6305:50382). Do not edit.
//
// The "state" axis is interaction state, so it is not a prop: hover and hovered are `hover:`, pressed is `active:`, focus is `focus:`,
// and disabled is applied in JS because react-native-web renders a div, which
// Tailwind's `disabled:` never matches.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const buttonContract = {
    component: 'Button',
    nodeId: '6305:50382',
    section: '[Web] Primitives',
    composes: [] as readonly ContractComposition[],
    stateAxis: 'state',
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        {
            note: 'primaryAxisAlignItems CENTER on a row that hugs — no slack to align in, so the file states an alignment it does not draw',
            count: 64,
            property: 'primaryAxisAlignItems',
            stated: 'CENTER',
        },
    ] as readonly ContractDisagreement[],
    textStyleIds: ['S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,'],
    props: {
        instance: { kind: 'instance_swap' },
        label: { kind: 'text' },
        showIconLeft: { kind: 'boolean' },
        showIconRight: { kind: 'boolean' },
        showLabel: { kind: 'boolean' },
        size: { kind: 'enum', values: ['small', 'big'] },
        type: { kind: 'enum', values: ['primary', 'secondary', 'text', 'destructive'] },
    },
    variants: {
        'size=big, type=destructive': {
            container:
                'bg-destructive-default rounded-common px-m py-s gap-xs h-[3rem] items-center hover:bg-destructive-hover active:bg-destructive-pressed',
            label: 'text-content-knockout text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'text-wrapper': 'px-xs items-center',
                'Button': 'text-content-knockout text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Button: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
        'size=big, type=primary': {
            container:
                'bg-primary-default rounded-common px-m py-s gap-xs h-[3rem] items-center hover:bg-primary-hover active:bg-primary-pressed',
            label: 'text-content-on-primary text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'text-wrapper': 'px-xs items-center',
                'Button': 'text-content-on-primary text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Button: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
        'size=big, type=secondary': {
            container:
                'group/button border-primary-default border-2 rounded-common px-m py-s gap-xs h-[3rem] items-center hover:bg-primary-hover active:bg-primary-pressed',
            label: 'text-content-default text-left group-hover/button:text-content-on-primary group-active/button:text-content-on-primary',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'text-wrapper': 'px-xs items-center',
                'Button':
                    'text-content-default text-left group-hover/button:text-content-on-primary group-active/button:text-content-on-primary',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Button: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
        'size=big, type=text': {
            container:
                'rounded-common px-m py-s gap-xs h-[3rem] items-center hover:bg-background-surface-hover active:bg-background-surface',
            label: 'text-content-default text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'text-wrapper': 'px-xs items-center',
                'Button': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Button: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
        'size=small, type=destructive': {
            container:
                'bg-destructive-default rounded-common px-m gap-xs h-[2.5rem] items-center hover:bg-destructive-hover active:bg-destructive-pressed',
            label: 'text-content-knockout text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'text-wrapper': 'px-xs items-center',
                'Button': 'text-content-knockout text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Button: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
        'size=small, type=primary': {
            container:
                'bg-primary-default rounded-common px-m gap-xs h-[2.5rem] items-center hover:bg-primary-hover active:bg-primary-pressed',
            label: 'text-content-on-primary text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'text-wrapper': 'px-xs items-center',
                'Button': 'text-content-on-primary text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Button: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
        'size=small, type=secondary': {
            container:
                'group/button border-primary-default border-2 rounded-common px-m gap-xs h-[2.5rem] items-center hover:bg-primary-hover active:bg-primary-pressed',
            label: 'text-content-default text-left group-hover/button:text-content-on-primary group-active/button:text-content-on-primary',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'text-wrapper': 'px-xs items-center',
                'Button':
                    'text-content-default text-left group-hover/button:text-content-on-primary group-active/button:text-content-on-primary',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Button: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
        'size=small, type=text': {
            container:
                'rounded-common px-m gap-xs h-[2.5rem] items-center hover:bg-background-surface-hover active:bg-background-surface',
            label: 'text-content-default text-left',
            icon: '',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'text-wrapper': 'px-xs items-center',
                'Button': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Button: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
